import angular from 'angular';
import ComponentsModule from '../components-module';
import ContentVersionTemplate from './content-version-modal.html';

const COMPONENT_NAME = 'ContentVersionModal';

angular.module (ComponentsModule)
  .factory (COMPONENT_NAME, ($rootScope, $uibModal, ContentService, ErrorMessagingService, KeyboardShortcutService) => {
    return {
      open: function (parentScope, version, template, enableEdit, hideEdit) {
        let modalScope = $rootScope.$new(true, parentScope);

        modalScope.template = template;
        modalScope.mode = 'view';
        modalScope.loading = true;
        modalScope.creationTime = version.creationTime;
        modalScope.version = version.version;
        modalScope.username = version.creatorId;
        modalScope.views = version.views;
        modalScope.editEnabled = enableEdit;
        modalScope.hideEdit = hideEdit;

        if (enableEdit) {
          modalScope.editHooverText = 'content-version-modal.edit.title';
        } else {
          modalScope.editHooverText = 'content-version-modal.edit.in-edit.title';
        }

        modalScope.updateActiveView = function (parentIndex, index) {
          modalScope.activeViewMap[parentIndex] = index;
        };

        modalScope.isActiveView = function (parentIndex, index) {
          if (!modalScope.activeViewMap[parentIndex]) {
            return index === 0;
          } else {
            return modalScope.activeViewMap[parentIndex] === index;
          }
        };

        ContentService.getContentVersion ({
          version: version.version,
          fullTypeInfo: true
        })
          .then (function (result) {
            modalScope.content = result.content;
          })
          .then (function () {
            modalScope.loading = false;

            const modal = $uibModal.open({
              scope: modalScope,
              template: ContentVersionTemplate,
              windowClass: 'code-generic-modal code-ui ng-cloak',
              backdrop: 'static',
              keyboard: false
            });

            modal.result.catch (() => { /* Ignore errors for now... */ });

            modalScope.close = function () {
              modal.close();
              modalScope.$destroy();
            };

            modalScope.edit = function () {
              modalScope.$emit('content-version-modal:edit', modalScope.content.system.version);
            };

            modalScope.$on('$destroy', function () {
              KeyboardShortcutService.pop();
            });

            if (enableEdit && !hideEdit) {
              KeyboardShortcutService.hideAndPush(
                {
                  'mod+e': {
                    action: function (event) {
                      modalScope.$apply(function () {
                        event.stopPropagation();
                        event.preventDefault();

                        modalScope.edit();
                        modalScope.close();
                      });
                    },
                    label: 'keyboard-shortcuts.edit-version.label'
                  },
                  'escape': {
                    action: function () {
                      modalScope.close();
                    },
                    label: 'keyboard-shortcuts.close-version-modal.label'
                  }
                }
              );
            } else {
              KeyboardShortcutService.hideAndPush({
                'escape': {
                  action: function () {
                    modalScope.close();
                  },
                  label: 'Ckeyboard-shortcuts.close-version-modal.label'
                }
              });
            }
          })
          .catch((error) => {
            ErrorMessagingService.sendError(error);
          });
      }
    };
  });

export default COMPONENT_NAME;
